import { render, staticRenderFns } from "./SettingDetail.vue?vue&type=template&id=02e39457&scoped=true&"
import script from "./SettingDetail.vue?vue&type=script&lang=js&"
export * from "./SettingDetail.vue?vue&type=script&lang=js&"
import style0 from "./SettingDetail.vue?vue&type=style&index=0&id=02e39457&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e39457",
  null
  
)

export default component.exports